import Link from 'next/link'
import React from 'react'
import { LogoHeaderMobile } from '~shared/components/logo-header-mobile'

export const ProgramHeader = () => {
  return (
    <header className='my-[24px]'>
      <div className='container container-slim flex justify-between items-center'>
        <Link href='/'>
          <LogoHeaderMobile />
        </Link>
        <nav className='text-[#1D1D1D] max-w-[375px] w-full'>
          <ul className='flex w-full justify-between'>
            <li className='hover:underline'>
              <Link href='/'>О профессии</Link>
            </li>
            <li className=' hover:underline'>
              <Link href='/'>Программа</Link>
            </li>
            <li className=' hover:underline'>
              <Link href='/'>Стоимость</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}
